import DataBlock, {DataBlockGrid} from "../DataBlock/DataBlock";
import {Button, Form, Input, Select, Table} from "antd";
import React, {useState} from "react";
import WarehouseSelect from '@/components/WarehouseSelect/WarehouseSelect';
import Lang from "@components/Lang/Lang";
import DetailCustomer from "./DetailCustomer/DetailCustomer";
import "./InventoryCustomer.less"

const {Option} = Select;

/**
 * 客户库存
 * @param {Object} props 组件属性
 * @returns {JSX.Element}
 * @constructor
 */
const InventoryCustomer = props => {
    /**
     * 查询类型
     */
    const type = 1;

    /**
     * 状态
     */
    let status = __getDictList("ddp_abd_buyer_storage_status");

    /**
     * 分页
     */
    const [pagingQuery, setPagingQuery] = useState({
        pageIndex: 1,
        pageSize: 10,
    });

    /**
     * 列表数据
     */
    const dataSource = props.dataSource || [];

    /**
     * 数据统计
     */
    const dataStatistics = props.dataStatistics || {};

    /**
     * 订单编号
     */
    const [poCode, setPoCode] = useState(null);

    /**
     * 客户编号
     */
    const [buyerCode, setBuyerCode] = useState(null);

    /**
     * 状态
     */
    const [buyerType, setBuyerType] = useState(null);

    /**
     * 所有仓库
     */
    const [transitCityIds, setTransitCityIds] = useState(null);
    /**
     * 计量单位
     */
    const Kuan = Lang({id: "Kuan", default: "款"});
    const Xiang = Lang({id: "Xiang", default: "箱"});
    const SouSuo = Lang({id: "SouSuo", default: "搜索"});

    /**
     * 表格栏目
     *
     * @type {[{dataIndex: string, title}, {dataIndex: string, title}, {dataIndex: string, title}, {dataIndex: string, title}, {dataIndex: string, title: string}, null]}
     */
    const columns = [
        {
            title: Lang({id: "KeHu", default: "客户"}),
            dataIndex: "buyerCode",
        },
        {
            title: Lang({id: "DingDanShu", default: "订单数"}),
            dataIndex: "poCount",
        },
        {
            title: Lang({id: "ZhuangTai", default: "状态"}),
            dataIndex: "typeName",
        },
        {
            title: Lang({id: "ShangPinKuanShu", default: "商品款数"}),
            dataIndex: "itemCount",
        },
        {
            title: Lang({id: "KuCun", default: "库存"}) + `(${Xiang})`,
            dataIndex: "boxCount",
        },
        {
            title: Lang({id: "CaoZuo", default: "操作"}),
            render: (text, record) => (
                <DetailCustomer buyerId={record.buyerId}/>
            )
        }
    ];

    /**
     * 查询参数
     */
    let queryParams = {type, poCode, buyerCode, buyerType, pagingQuery,transitCityIds}

    /**
     * 分页
     */
    const handlePagination = (pagination) => {
        queryParams.pagingQuery.pageIndex = pagination.current;
        queryParams.pagingQuery.pageSize = pagination.pageSize;
        setPagingQuery(queryParams.pagingQuery);
        props.onQuery(queryParams);
    }

    /**
     * 搜索
     */
    const handleSearch = () => {
        queryParams.pagingQuery.pageIndex = 1;
        setPagingQuery(queryParams.pagingQuery);
        props.onQuery(queryParams);
    }

    /**
     * 渲染视图
     */
    return (
        <div className="InventoryCustomer">
            {/* 筛选组件 */}
            <Form className="search" layout="inline">
                <Form.Item>
                    <WarehouseSelect onChange={(dat)=>setTransitCityIds(dat)} />
                </Form.Item>
                <Form.Item label={Lang({id: "DingDanBianHao", default: "订单编号"})}>
                    <Input placeholder={SouSuo} onChange={(e) => setPoCode(e.target.value)}/>
                </Form.Item>
                <Form.Item label={Lang({id: "KeHuBianHao", default: "客户编号"})}>
                    <Input placeholder={SouSuo} onChange={(e) => setBuyerCode(e.target.value)}/>
                </Form.Item>
                <Form.Item label={Lang({id: "ZhuangTai", default: "状态"})}>
                    <Select defaultValue={null} onChange={(value) => setBuyerType(value)} style={{width: 153}}>
                        <Option value={null}><Lang id="QuanBu">全部</Lang></Option>
                        {status.map(item => (<Option key={item.code} value={item.code}>{item.name}</Option>))}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button type="text" onClick={handleSearch}><Lang id="SouSuo" default="搜索"/></Button>
                </Form.Item>
            </Form>

            {/* 数据统计 */}
            <DataBlockGrid span="4">
                <DataBlock subject={Lang({id: "ShangPinZongJi", default: "商品总计"}) + `(${Kuan})`} count={dataStatistics.total || 0}/>
                <DataBlock subject={Lang({id: "ShangPinZongKuCun", default: "商品总库存"}) + `(${Xiang})`} count={dataStatistics.stockTotal || 0}/>
                <DataBlock subject={Lang({id: "WeiFuKuan", default: "未付款"}) + `(${Xiang}) ${dataStatistics.nonPayStockPercentage || 0}%`} count={dataStatistics.nonPayStockTotal || 0}/>
                <DataBlock subject={Lang({id: "DaiChuKu", default: "待出库"}) + `(${Xiang}) ${dataStatistics.payStockPercentage || 0}%`} count={dataStatistics.payStockTotal || 0}/>
            </DataBlockGrid>

            {/* 数据列表 */}
            <Table loading={props.loading} dataSource={dataSource} columns={columns} rowKey="buyerId" onChange={handlePagination} pagination={{
                defaultPageSize: pagingQuery.pageSize,
                total: props.total,
                current: pagingQuery.pageIndex,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: total => `Total ${props.total} items`
            }}/>
        </div>
    );
};

export default InventoryCustomer;
